var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path2, _g9, _path3, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _path4, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommuni(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Streamer character elements collection 03-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #f2eae9 } \n\t\t.s2 { fill: #e34750 } \n\t\t.s3 { fill: #e4d9d6 } \n\t\t.s4 { fill: #323232 } \n\t\t.s5 { fill: #9a3b42 } \n\t\t.s6 { fill: #b7989b } \n\t\t.s7 { fill: #5c715f } \n\t\t.s8 { fill: #4a524b } \n\t\t.s9 { fill: #ffcd6f } \n\t\t.s10 { fill: #f1ce4b } \n\t\t.s11 { fill: #83e8e8 } \n\t\t.s12 { fill: #fec7a0 } \n\t\t.s13 { fill: #694949 } \n\t\t.s14 { fill: #de7767 } \n\t\t.s15 { fill: #1e2024 } \n\t\t.s16 { fill: #c1b2ae } \n\t\t.s17 { fill: #feb28e } \n\t\t.s18 { fill: #464646 } \n\t\t.s19 { fill: #8c6464 } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1024 1024h-1024v-1024h1024z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m929.9 506.1c0 180.5-114.4 334.2-274.7 392.7v-173.6h-256.7v183.2c-175.6-49.5-304.4-210.9-304.4-402.3 0-230.8 187.1-417.9 417.9-417.9 230.8 0 417.9 187.1 417.9 417.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m377.1 470.8q-0.6 16.5-1.7 29.4-2 0.2-5.1 0.2c-2.5 0.1-5.7 0-9.1-0.3-7.7-0.7-16.6-2.9-20.9-8.6-4.5-5.9-8.2-21.2-9.8-36.7-1.5-14-1.4-28.3 1.2-36.2 4-12.4 12.7-17.1 23.5-17.4q2.7-0.1 5.6 0.2 3.1 0.3 6.5 1c10.2 2 10.8 40.3 9.8 68.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m656.6 459.5c-0.6 14-2.7 26.8-6.7 32-4.4 5.7-13.2 7.9-20.9 8.6-3.4 0.3-6.6 0.4-9.1 0.3q-3.1 0-5.1-0.2-1.4-15.8-1.9-34.6c-0.6-22 0-48.3 5.3-58.7 1.2-2.5 2.8-4.1 4.7-4.5q3.3-0.7 6.5-1 2.9-0.3 5.6-0.2c10.8 0.3 14.1 2.3 18.1 14.7 1.4 4.3 2.5 10.8 3.1 18.1 0.7 7.9 0.8 16.9 0.4 25.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m377.1 470.8q-0.6 16.5-1.7 29.4-2 0.2-5.1 0.2c-2.5 0.1-5.7 0-9.1-0.3-2.7-8.1-5.6-18.6-7.5-31-3-19.1-3.8-42.4 1.5-67.9q2.7-0.1 5.6 0.2 3.1 0.3 6.5 1c10.2 2 10.8 40.3 9.8 68.4z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m638.9 438.7c0 9.3-0.7 18.2-1.8 26.3-1.9 14.1-5.1 26.1-8.1 35.1-3.4 0.3-6.6 0.4-9.1 0.3q-3.1 0-5.1-0.2-1.4-15.8-1.9-34.6c-0.6-22 0-48.3 5.3-58.7 1.2-2.5 2.8-4.1 4.7-4.5q3.3-0.7 6.5-1 2.9-0.3 5.6-0.2c2.7 13.1 3.9 25.7 3.9 37.5z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m377 393.7q1.1-45.9 8.7-69.7c7.5-23.7 23.8-40.5 78.9-50.2 55.1-9.7 125.3 0.5 141 43.2q15.7 42.7 11.3 102.7l-236.6-0.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m400.8 502.9q-7 11.3-23.2 6.5c-2.7-0.9-5.2-4.1-7.3-9-3.2-7.1-5.8-17.7-7.7-29.5-4.1-25.7-5-57.1-1.8-69.5q0.4-2 1.1-3.3c7.6-15.2 28.6-7.6 29.7-3.3q1.9 39.2 4.6 71c1.4 16.5 3 31 4.6 37.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m400.8 502.6q-7 11.3-23.2 6.5c-2.7-0.9-5.2-4.1-7.4-9-2.5 0.1-5.6 0-9-0.3-7.7-0.7-16.6-2.9-20.9-8.6-4.6-5.9-8.2-21.2-9.9-36.7 6.2 6.1 13.8 11.4 23.3 14.3q4.2 1.3 8.9 1.8c4.5 0.6 9.3 0.6 14.5-0.1 5.9-0.8 12.2-2.4 19.1-5 1.3 16.5 2.9 31 4.6 37.1z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m630.9 438.9c-0.5 8.8-1.3 18.1-2.6 27-1.9 13.7-4.8 26.4-8.4 34.5-2.1 4.9-4.6 8.1-7.3 9-8.9 2.6-15 0.4-18.7-2.1q-3.1-2.1-4.5-4.4 4.8-17.9 9.2-108.1c0.6-2.4 7.5-5.9 14.8-5.7 5.7 0.1 11.6 2.3 14.9 9q0.6 1.3 1.1 3.3c1.9 7.5 2.3 21.7 1.5 37.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m656.6 459.5c-0.6 14-2.7 26.8-6.7 32-4.4 5.7-13.2 7.9-20.9 8.6-3.4 0.3-6.6 0.4-9.1 0.3-2.1 4.9-4.6 8.1-7.3 9-8.9 2.6-15 0.4-18.7-2.1l0.7-45.1q7.3 2.4 18.3 3.4c4.6 0.4 9.8 0.6 15.4 0.3q4.3-0.3 8.8-0.9c6.4-1 13-2.7 19.5-5.5z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m354.9 854.1q-21.6 31.3-45.4 57.2c-23.8 26-40 31.4-71.3 23.8q-31.4-7.5-31.4-43.2 23.8-120 29.2-129.7 5.4-9.7 47.6 9.7 17.3-115.6 34.5-135 17.3-19.5 47.6-20.6l-27-59.4c175.7 27.9 294.1-26.1 296-27q0.1 0 0.1 0l-10.8 60.5q72.4 5.4 91.8 112.4l-36.7 27 21.1 183.2h-336.2z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m432 913l-54.6-297q107.8-46.6 214.8-25.8c10.6 2 21.2 4.7 31.7 8.2 88.8 29.6 38.5 224.4 9.8 314.6z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m594.6 586.6c10.6 2.1 21.2 4.8 31.7 8.3 89.9 30 37.1 229.5 8.6 318.1h-95.6c23.2-78 80-281.8 55.3-326.4z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m583.8 913c20.1-340.8 50-381.9 50.9-383.1q0.1 0 0.1 0l-10.8 60.5q72.4 5.4 91.8 112.4l-32.1 23.6-4.6 3.4 21.1 183.2z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m683.4 740.9h-57.9v-23.5h57.9z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m662.7 694.7l21 31.7-4.6 3.4 21.1 183.2h-68.8c16.9-23.7 54.4-93.2 31.3-218.3z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m456.4 913h-92.4l-9.1-58.9q-21.6 31.3-45.4 57.2c-23.8 26-40 31.4-71.3 23.8q-31.4-7.5-31.4-43.2 23.8-120 29.2-129.7 5.4-9.7 47.6 9.7 6.1-123.5 23.4-143 17.2-19.4 58.7-12.6l-27-59.4c0.9 0.6 61.7 41.7 83.2 118.9 16.7 60 29.5 183.9 34.5 237.2z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m303.8 819.4c-10.6-1.6-24.4-5.6-39-14.7-8.5-5.3-14.8-10.6-19.2-15.5-12.3-13.8-9.8-24.4-0.2-23.4 2.1 0.3 5.9 1.4 10.8 3.3 14.9 5.6 39.8 17.6 56.3 29.1 8.7 6 15.1 11.8 16.5 16.6 0.8 2.4-0.8 5.1-3.3 5.8q-8.8 0.8-21.9-1.2z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m390 250.2l-6-13.8-13.8 5.9-6-14 13.8-5.9-5.9-13.8 14-6 5.9 13.8 13.9-5.9 6 14-13.9 5.9 6 13.8zm-3.9-19l6 13.8 6.6-2.9-5.9-13.8 13.8-5.9-2.8-6.7-13.8 6-6-13.9-6.6 2.9 5.9 13.8-13.8 5.9 2.8 6.7z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m286.7 554.7c-11.7 0-21.2-9.5-21.2-21.3 0-11.7 9.5-21.2 21.2-21.2 11.8 0 21.3 9.5 21.3 21.2 0 11.8-9.5 21.3-21.3 21.3zm0-38.5c-9.5 0-17.2 7.7-17.2 17.2 0 9.6 7.7 17.3 17.2 17.3 9.6 0 17.3-7.7 17.3-17.3 0-9.5-7.7-17.2-17.3-17.2z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s10",
    d: "m702.5 454.4l-14.1-14.1 14.1-14.1 14.1 14.1zm-8.4-14.1l8.4 8.4 8.4-8.4-8.4-8.4z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m818.3 584.5l-41.6-11.1 30.4-30.5zm-33.9-13.3l28.3 7.6-7.6-28.2z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m144.7 756.2l-0.3-4 17.8-1.5 10.7-15.4 18.8-1.6 10.7-15.5 19.7-1.6 0.4 4-17.9 1.5-10.7 15.4-18.8 1.6-10.7 15.4z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 208.2,
    cy: 341.7,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 224,
    cy: 341.7,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 239.7,
    cy: 341.7,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 255.5,
    cy: 341.7,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 271.3,
    cy: 341.7,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 287,
    cy: 341.7,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 302.8,
    cy: 341.7,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 318.6,
    cy: 341.7,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 334.3,
    cy: 341.7,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 216.2,
    cy: 354.2,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 232,
    cy: 354.2,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 247.7,
    cy: 354.2,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 263.5,
    cy: 354.2,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 279.3,
    cy: 354.2,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 295,
    cy: 354.2,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 310.8,
    cy: 354.2,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 326.6,
    cy: 354.2,
    r: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s10",
    cx: 342.3,
    cy: 354.2,
    r: 2.4
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m396.7 340.1c7.2-46.9 105.9-53.3 128.9-54.8q23.1-1.4 28.1 18c46.8-4.3 44 84.3 44 88.6 0 4.4 7.9 108.1-15.2 153.5-23 45.4-72 43.2-111.6 37.4-39.7-5.7-62.7-41.7-69.2-67q-6.5-25.2-10.1-121-2.1-7.9 5.1-54.7z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m599 436.9q0 2.3 0 4.7c-0.3-0.6-0.5-1.3-0.6-2.1q-0.2-1.3-0.4-2.9c-2-17.6-4.5-57.1-27-72-6.2-4.2-10.7-9.9-14-16.1q-1.4-2.6-2.5-5.3c-1.8-4.4-3.1-8.8-4.1-12.9-0.7-3.3-1.2-6.3-1.6-9.1q-0.9-7.1-0.8-12.1-58.4 46.1-105.9 9.4c-10.8-4.7-17.9-2.1-21.9 3-1.5 1.9-2.5 4.1-3.2 6.4-1 3.2-1.2 6.5-0.9 9.6q0 0.2 0 0.4c0.4 3.3 0.7 7.1 0.6 11.2-0.3 10.1-3.3 21.8-13.5 32-6.1 6.1-9.3 18.3-10.8 30.3q-0.5-10.1-0.8-16.6-1.9-7.1 4.1-48 0.4-3.2 1-6.7 0.6-4.2 2.2-8c1.4-3.4 3.3-6.5 5.7-9.4 5.6-6.8 13.5-12.4 22.8-16.9q0 0 0 0 1.4-0.8 2.9-1.4c33-15.1 80.3-18.1 95.3-19.1 12.8-0.8 20 4.8 23.9 10q3.2 4.1 4.2 8c5.2-0.4 9.7 0.2 13.7 1.7 4.3 1.7 7.9 4.3 11.1 7.6 5.7 6.1 9.8 14.6 12.6 23.8 1.3 4.2 2.3 8.6 3.2 12.9 4 20.5 3.4 40.6 3.4 42.6 0 1.8 1.3 20.5 1.3 45z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m595.4 593.4c-9.6 32.3-43 57-91.4 60.8-45.7 3.6-79.6-35.3-89.8-48.6 6.6-3.5 12.2-6.6 16.3-9.4q1.9-1.3 3.3-2.6c6.8-5.9 8.1-15.3 8.1-21.6 8.4 5.3 18 9.2 29 10.8 33 4.9 72.6 7.1 98.2-18.6 3 10.1 6 16.7 9.4 21.1 4.5 5.8 9.8 7.6 16.9 8.1z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m578.5 585.3c-24.4 38.1-64.3 53-101.7 47.6-16.3-2.4-35.6-27-46.3-36.7q1.9-1.3 3.3-2.6c6.8-5.9 8.1-15.3 8.1-21.6 8.4 5.3 18 9.2 29 10.8 33 4.9 72.6 7.1 98.2-18.6 3 10.1 6 16.7 9.4 21.1z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m773.1 630.4q23.8 150.2 30.2 180.5c6.5 30.2-2.1 83.2-54 86.4q-51.9 3.2-65.9-70.2l-35.8-157.9c-0.6-2.6 0.4-5.3 2.6-6.8q64.5-46.6 122.9-32z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m708.8 640.1c14-5.4 64.8-15.1 58.3-2.7-6.4 12.4-72.4 34.6-90.2 36.8q-17.8 2.1-23.8-5.4c6-10.9 41.6-23.3 55.7-28.7z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s15",
    cx: 757.2,
    cy: 681.9,
    r: 10.4
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s15",
    cx: 229.6,
    cy: 806.2,
    r: 10.4
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m257.7 202l31-16.5 36 67-21.6 1.4 26.6 41.1-54.7-50.5 18-2.8z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m702.8 175.8l-35.3 38.2 25.3 3.6-61.3 67 29.6-53.3-23.8-3.6 25.2-51.2z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m558.6 491q-0.1 3.4-0.8 8.6c-0.9 6.7-2.7 16.3-6.3 25.9-6.4 16.7-18.4 33.3-41 34.1-34.2 1.2-47.5-7.2-54.2-35-1.7-7.1-3-15.3-4.1-25q-0.6-5.1-1.1-10.8z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m505.6 435.3c0.1 1.8 0.6 3.4 1.3 4.8 0.7 1.4 1.6 2.7 2.5 3.9 0.5 0.6 1.1 1.1 1.6 1.7 0.5 0.5 1 1.1 1.6 1.6 0.6 0.5 1.1 0.9 1.9 1.8 0.4 0.4 0.8 0.9 1.1 1.3 0.3 0.5 0.6 1 0.9 1.6 0.5 1.1 0.8 2.3 0.9 3.5 0.2 1.2 0 2.3-0.2 3.4-0.6 2.2-1.6 4-2.8 5.6-1.3 1.5-2.7 2.7-4.2 3.7-1.6 1-3.3 1.8-5.1 2.3 1.7-3.4 3.4-6.2 4.6-9 0.6-1.4 1.1-2.7 1.2-3.8 0.1-0.6 0.1-1.2 0.1-1.7-0.1-0.5-0.2-0.9-0.4-1.4-0.3-1-1-1.7-2.3-3.4-0.6-0.7-1.1-1.5-1.7-2.3-0.4-0.9-0.9-1.7-1.2-2.6-0.8-1.7-1.3-3.7-1.3-5.6 0-1.9 0.4-3.9 1.5-5.4z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "<Path>",
    className: "s4",
    cx: 457.8,
    cy: 438.3,
    rx: 4.6,
    ry: 5.7
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "<Path>",
    className: "s4",
    cx: 544.8,
    cy: 438.3,
    rx: 4.6,
    ry: 5.7
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m427.8 396.4q22.2-24.8 45.4-8.1-0.5 6.5-17.3 3.8-16.7-2.7-28.1 4.3z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m541.3 392.1q-16.8 2.7-17.3-3.8 23.2-16.7 45.4 8.1-11.4-7-28.1-4.3z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m558.6 491q-0.1 3.4-0.8 8.6h-105.6q-0.6-5.1-1.1-10.8z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m551.5 525.5c-6.4 16.7-18.4 33.3-41 34.1-34.2 1.2-47.5-7.2-54.2-35 9.6-10.5 27.2-17.4 47.2-17.4 20.6 0 38.5 7.4 48 18.3z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m439.2 543.7q0 0-0.1 0c-1.5 0-36.6-0.5-47.5-3.3-10.8-2.7-9.9-22.4-9.5-32 0-1.1 0.1-2.4 0.1-2.9-0.3-1.2 0.4-2.4 1.6-2.8 1.3-0.5 2.7 0.2 3.2 1.5 0.2 0.8 0.2 1.5 0.1 4.5-0.3 6.2-1.1 25.2 5.7 26.9 10.4 2.6 46.1 3.1 46.4 3.1 1.4 0.1 2.5 1.2 2.5 2.6 0 1.3-1.2 2.4-2.5 2.4zm-57-37.9q0 0 0 0 0 0 0 0z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m501.3 688.7q-1.1 1.2-2.4 2.2c-8.7 7.3-23.6 11-33.1 5q-15.8-16.5-23.4-26.2l-4.3-4.4-5 3.3q-2.6 10.1-11.2 11.5c-8.7 1.4-14.1-1.1-21.3-10.8l-20.5 10.8q7.9 20.2-7.2 22.7-15.1 2.5-52.6-4.3l-5-1.1-1.2-13.4-1.4-15.8q-2.7-10.1-3.6-19.4c-0.8-6.9-0.5-13.5 2.6-15.2q7.2-3.9 26.4-14.6l86.5-30.2q19.4-10.8 32.9 10.3c13.6 21 51.9 81 43.8 89.6z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m498.9 690.9c-8.7 7.3-23.6 11-33.1 5q-15.8-16.5-23.4-26.2l-4.3-4.4-5 3.3q-2.6 10.1-11.2 11.5c-8.7 1.4-14.1-1.1-21.3-10.8l-20.5 10.8q7.9 20.2-7.2 22.7-15.1 2.5-52.6-4.3l-5-1.1-1.2-13.4-1.4-15.8q-2.7-10.1-3.6-19.4l119.3-47.6q15.1-10.2 28.6 14.6c9.8 18.1 31.1 55.9 41.9 75.1z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m378 698.1c-3.8 5.1-11.9 5.5-18.2 0.8-6.2-4.6-8.2-12.5-4.4-17.6 3.8-5.1 11.9-5.4 18.2-0.8 6.2 4.7 8.2 12.6 4.4 17.6z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m735.8 655.2q-11.2 7.9-30.4 13.3c-6.1 1.7-12.9 3.1-20.4 4q-7-45.4-14.6-51.8c-7.5-6.5-15.6-16.8-16.2-47q-5.4 10.2-11.3 5.9-6-4.3-5.4-44.3 0 0 0 0c0.1-0.5 2.3-7 7.5-7.6q1.7-9.7 14.6-10.2 0-6.5 10.8-7.6 3.3-4.9 9.2-4.3 6 0.5 40 3.8 13.5-3.8 13 24.8-0.6 28.6 3.2 121z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m705.4 668.5c-6.1 1.7-12.9 3.1-20.4 4q-7-45.4-14.6-51.8c-7.5-6.5-15.6-16.8-16.2-47q-5.4 10.2-11.3 5.9-6-4.3-5.4-44.3 0 0 0 0c0.2-0.3 2.9-3.3 17.7-1.8 15.7 1.5 29.8 0 29 14.8-0.8 14.9-7.5 36 9 73.6 6.7 15.4 10.3 32.1 12.2 46.6z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m656.2 557.7c0.3 1.4 0.5 2.7 0.6 4.1q0.1 2-0.2 4.1c-0.1 1.3-0.3 2.7-0.7 4-0.4 1.4-0.9 2.6-1.7 3.8 0.6-2.7 0.6-5.3 0.3-7.8-0.1-1.3-0.3-2.6-0.5-3.8-0.2-1.3-0.5-2.6-0.7-3.8-0.2-0.8 0.4-1.6 1.2-1.8 0.8-0.1 1.5 0.4 1.7 1.2z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m647.2 554.7c2.1 0 3.8 0.4 5.5 0.8 1.8 0.3 3.5 0.7 5.2 0.9 1.8 0.2 3.6 0.3 5.4 0.2 1.8-0.1 3.6-0.4 5.5-0.8-1.6 1-3.4 1.9-5.2 2.3-1.9 0.6-3.8 0.9-5.8 0.9-2 0-3.9-0.2-5.8-0.8-1.8-0.7-3.7-1.6-4.8-3.5z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m645 527.7c2.8-1.2 5.6-1.1 8.4-1.1q4.1 0.1 8.3 0.6 4.1 0.4 8.2 1.1c2.7 0.5 5.5 1.1 8.1 2.1-2.8-0.2-5.5-0.4-8.3-0.6-2.7-0.2-5.4-0.3-8.2-0.4q-4.1-0.1-8.2-0.2c-1.4-0.1-2.8-0.1-4.2-0.3-1.3-0.2-2.7-0.5-4.1-1.2z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m659.6 517.5c3.3-1.1 6.5-0.8 9.8-0.9q2.4 0 4.8 0.1c1.7 0 3.3 0 4.9 0.1 3.2 0 6.5 0.2 9.7 0.4 3.3 0.2 6.5 0.5 9.7 1.3-3.2 0.7-6.5 0.9-9.7 0.9-3.3 0-6.5-0.1-9.8-0.1-1.6-0.1-3.2-0.2-4.8-0.2q-2.5-0.1-4.9-0.3c-3.2-0.2-6.5-0.1-9.7-1.3z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m670.4 509.9c2.7-0.9 5.4-0.9 8.1-0.9q4.1-0.1 8.1 0.1l8.1 0.5c2.7 0.2 5.4 0.4 8.1 0.8-2.7 0.4-5.4 0.5-8.1 0.6l-8.1 0.2q-4 0.1-8.1-0.1c-2.7-0.1-5.4-0.2-8.1-1.2z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m363.5 705.7q7.2 6.8 4.7 10.4-0.3 0.4-0.6 0.8c-2.7 3.1-8 4.4-12.4 2.1q-12.9 8.3-13.6 12.3c-0.8 3.9-2.2 30.2-11.6 36.3-4.7 3.1-11.7 17.3-17.5 30.6-3.7 8.4-6.9 16.5-8.7 21.2-4.8-0.7-10.3-2-16.2-3.9-7.1-2.4-14.8-5.8-22.8-10.8-8.5-5.3-14.8-10.6-19.2-15.5 1.2-2 6.4-10.8 10.6-20.1 3.2-6.8 5.8-13.9 5.8-18.4q0-11.5 15.8-91.5 11.5-39.6 31.7-40.3 20.2-0.8 36 1.4 2.9 18-33.8 18-3.3 7.9-7.2 26.3l26.3-11.2q9.7-1.8 13.3 1.8 3.6 3.6 27.4 25.3-1.8 5.4-8.7 6.1l12.3 13.3q-4.4 7.6-11.6 5.8z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m367.6 716.9c-2.7 3.1-8 4.4-12.4 2.1q-12.9 8.3-13.6 12.3c-0.8 3.9-2.2 30.2-11.6 36.3-4.7 3.1-11.7 17.3-17.5 30.6-3.7 8.4-6.9 16.5-8.7 21.2-4.8-0.7-10.3-2-16.2-3.9 3.3-4.7 14.4-20.6 17-29.3 3.1-10.1 25.8-16.4 27.4-35.2 1.6-18.8 3.1-27.4 7.8-32.1q4.7-4.7 15.7-7.8 5.6-1.1 12.1 5.8z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m286.8 671.5c0.3 0.4 0.6 0.7 0.9 0.9 0.4 0.2 0.8 0.3 1.2 0.3 0.8-0.1 1.6-0.6 2.2-1.2 1.5-1.2 3.1-2.2 4.7-3.3q4.8-3 9.8-5.7c0.7-0.3 1.6-0.1 2 0.7 0.4 0.7 0.1 1.6-0.6 2q0 0-0.1 0l-10.1 4.9c-1.6 0.8-3.3 1.6-4.9 2.6-0.9 0.5-1.9 0.8-3 0.7-1.1-0.1-1.9-1-2.1-1.9z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m294.9 683.9c1.7 0.8 3.5 1.5 5.2 1.9 0.9 0.3 1.8 0.4 2.6 0.3q0.3 0 0.6 0c0.2 0 0.4 0 0.6-0.1l0.5-0.2 0.6-0.2c3.5-1.3 7.1-2.6 10.6-3.9l10.7-3.9 10.6-3.8-0.3 0.1c0.6-0.3 0.8-0.4 1.2-0.5q0.6-0.2 1.1-0.3 1.1-0.2 2.2-0.1c1.4 0 2.9 0.3 4.1 0.9q1 0.5 1.8 1l1.5 1q1.5 0.9 3 1.8 3 1.9 6 3.7l6 3.7c0.7 0.4 1 1.3 0.5 2-0.4 0.7-1.2 0.9-1.9 0.6-4.3-2.1-8.4-4.4-12.5-6.8q-1.6-0.9-3.1-1.8l-1.5-1q-0.6-0.4-1.3-0.7-1.4-0.6-2.7-0.6-0.7 0-1.4 0.1-0.3 0.1-0.6 0.2c-0.2 0-0.4 0.1-0.4 0.2l-0.3 0.1h-0.1c-3.5 1.3-7.1 2.5-10.7 3.7-3.6 1.3-7.2 2.5-10.8 3.7-3.6 1.1-7.1 2.3-10.9 3.2l-0.8 0.2c-0.2 0-0.5 0-0.8 0.1-0.3 0-0.6 0-0.9 0q-0.4 0-0.8-0.1c-1-0.2-2-0.5-2.9-1-1.8-0.9-3.4-2.1-4.7-3.5z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m311.1 712c1 0.8 2.1 1.2 3.2 1.2 1 0.1 2-0.3 3-0.8 0.5-0.3 0.9-0.5 1.3-0.9l1.6-1q1.6-1.1 3.3-1.9 6.6-3.4 13.4-6.3 3.3-1.5 6.8-2.8l3.4-1.4 1.7-0.7 0.5-0.2c0 0 0 0 0.1-0.1q0.2 0 0.3 0 0.1-0.1 0.3-0.1 0.6-0.1 1.1-0.1c3-0.3 5.8 0.6 8.1 2.2 2.4 1.5 4.1 3.5 5.5 5.7 0.5 0.7 0.3 1.6-0.4 2.1-0.6 0.4-1.5 0.3-2-0.3v-0.1c-1.4-1.7-3.1-3.3-5-4.4-1.8-1.1-3.9-1.6-5.8-1.4q-0.4 0-0.7 0.1-0.1 0-0.1 0.1-0.1 0 0 0c0-0.1 0 0-0.1 0l-0.3 0.1-1.7 0.7-3.4 1.4-6.8 2.8c-4.5 1.9-9 3.8-13.4 5.8l-3.3 1.5-1.6 0.8c-0.3 0.1-0.6 0.3-0.9 0.4l-1 0.3c-1.4 0.4-2.9 0.5-4.2 0-1.4-0.5-2.4-1.5-2.9-2.7z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "<Path>",
    className: "s4",
    cx: 453.8,
    cy: 542,
    rx: 17.8,
    ry: 9.5
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m470.1 542.9q1.2-5.1-11.7-2.8-12.9 2.4-13.3-3.1 24.6-8.2 25 5.9z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m403.3 913h-39.3l-9.1-58.9-5.7-69q25.7 76 54.1 127.9z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m336.3 821.5q-9.4 37.5-27 63.4 34-42.3 27-63.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.2,
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m656.2 434c-4.7 1.7-11.2 3.8-17.3 4.7-2.8 0.4-5.6 0.5-8 0.2-5-0.6-8.6-3-9.1-8.5-0.6-7.7-2.1-16.1-3.6-23.5-1.7-7.9-3.6-14.6-4.8-17.8 5.7 0.1 11.6 2.3 14.9 9q0.6 1.3 1.1 3.3 2.9-0.3 5.6-0.2c10.8 0.3 14.1 2.3 18.1 14.7 1.4 4.3 2.5 10.8 3.1 18.1z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m416.7 349.1c-0.3 10.1-3.3 21.8-13.5 32-6.1 6.1-9.3 18.3-10.8 30.3q-0.5-10.1-0.8-16.6-1.9-7.1 4.1-48c4 4.1 10.5 5.9 21 2.3z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m599 436.9l-1-0.3c-2-17.6-4.5-57.1-27-72-6.2-4.2-10.7-9.9-14-16.1 11.2 3 25 4.7 37.3 0.8 4 20.5 3.4 40.6 3.4 42.6 0 1.8 1.3 20.5 1.3 45z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m567.4 305c-6.3 3-13.6 8-18.6 16.2q-0.9-7.1-0.8-12.1-58.4 46.1-105.9 9.4c-10.8-4.7-17.9-2.1-21.9 3l0.2-0.9q0-10.3 7-14.8 0 0 0 0 1.3-0.9 2.9-1.4c4.6-1.5 11.5-0.8 21.4 4.5 30.5 15.9 78.6 26.7 97.8-13.6q3.2 4.1 4.2 8c5.2-0.4 9.7 0.2 13.7 1.7z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: ""
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m591.1 336.4c-8.8-1.8-23.7-2.7-36.6 6.8-1.8-4.4-3.1-8.8-4.1-12.9 10.3-1.9 23.9-6.4 28.1-17.7 5.7 6.1 9.8 14.6 12.6 23.8z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m416.1 337.5c-4.9-2.3-11.1-4.7-17.2-5.4 1.4-3.4 3.3-6.5 5.7-9.4 3 2.6 7 4.7 12.4 5.2-1 3.2-1.2 6.5-0.9 9.6z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m426 675.7c-3.8 5.1-11.9 5.4-18.2 0.8-6.2-4.7-8.2-12.5-4.4-17.6 3.8-5.1 11.9-5.5 18.2-0.8 6.2 4.6 8.2 12.5 4.4 17.6z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m458.4 302.6q4.7-1.2 16 3.9l-8.6-5.1q14.1 5.1 35.6-3.9l-5.4 5.1q7.8-1.6 14 2l-10.1 6.2 10.9 3.1q-12.5 9.8-36.8-3.1-7-1.9-15.6-8.2z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m440.8 898.9q-8.2-135-22.3-199.5 30.5 106.8 22.3 199.5z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s0",
    cx: 149.7,
    cy: 435.6,
    r: 39.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s2",
    cx: 149.7,
    cy: 471.6,
    r: 39.1
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s2",
    x: 723.1,
    y: 273.8,
    width: 135,
    height: 84.5,
    rx: 19.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s0",
    cx: 790.6,
    cy: 316.1,
    r: 28.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m811.1 316.1l-14.2 8.2-14.2 8.2v-16.4-16.4l14.2 8.2z"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s2",
    x: 119.9,
    y: 599.6,
    width: 95.1,
    height: 92.7,
    rx: 12.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s4",
    cx: 167.5,
    cy: 646,
    r: 19.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s0",
    x: 192.7,
    y: 607.8,
    width: 16.4,
    height: 27,
    rx: 8.2
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s4",
    x: 765.4,
    y: 423.5,
    width: 150.3,
    height: 49.3,
    rx: 13.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s2",
    x: 780.6,
    y: 432.1,
    width: 16,
    height: 32.1,
    rx: 5.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s2",
    x: 801.4,
    y: 432.1,
    width: 16,
    height: 32.1,
    rx: 5.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s2",
    x: 822.1,
    y: 432.1,
    width: 16,
    height: 32.1,
    rx: 5.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s2",
    x: 842.8,
    y: 432.1,
    width: 16,
    height: 32.1,
    rx: 5.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s0",
    x: 863.6,
    y: 432.1,
    width: 16,
    height: 32.1,
    rx: 5.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s0",
    x: 884.3,
    y: 432.1,
    width: 16,
    height: 32.1,
    rx: 5.1
  }))))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "<Path>",
    className: "s0",
    cx: 456.3,
    cy: 436.8,
    rx: 2,
    ry: 2.2
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "<Path>",
    className: "s0",
    cx: 542.4,
    cy: 437.6,
    rx: 2,
    ry: 2.2
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m449.4 436.4q9.4-7.5 17.2 0.8-7.6-16.2-17.2-0.8z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m537 436.4q9.4-7.5 17.3 0.8-7.6-16.2-17.3-0.8z"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s4",
    x: 439.8,
    y: 132.7,
    width: 162.4,
    height: 84,
    rx: 18.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s2",
    cx: 477.9,
    cy: 158.9,
    r: 13.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m460.6 204.4v-9.4c0-9.5 7.7-17.3 17.3-17.3 9.5 0 17.2 7.8 17.2 17.3v9.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m522.7 162.7q0-3.1-1-4.2-1.1-1.2-2.8-1.2-1.8 0-2.8 1.1-1 1-1 3.6v3h-7v-2.5q0-5.8 2.7-8.8 2.8-3.1 8.3-3.1 5.4 0 8.2 3.1 2.8 3 2.8 8.8v1.2q0 7.5-5.2 9.7 2.9 1.2 4 3.7 1.2 2.5 1.2 6.1v3.7q0 5.8-2.8 8.8-2.8 3.1-8.2 3.1-5.5 0-8.3-3.1-2.7-3-2.7-8.8v-3.9h7v4.4q0 2.6 1 3.6 1 1.1 2.8 1.1 1.7 0 2.8-1.1 1-1.1 1-4.3v-3.7q0-3.3-1.1-4.6-1.2-1.3-3.7-1.3h-2.5v-6.8h2.9q2.1 0 3.2-1.1 1.2-1 1.2-3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m541.8 183.1v4.4q0 2.5 1 3.5 1.1 1.1 2.8 1.1 1.7 0 2.8-1.1 1-1 1-3.5v-10.4q0-2.6-1-3.6-1.1-1.1-2.8-1.1-1.7 0-2.8 1.1-1 1-1 3.6v1.4h-7l1.3-27.3h19.5v6.7h-12.8l-0.6 11.2q2.1-3.4 6.4-3.4 4.1 0 6.2 2.7 2 2.8 2 8v10.5q0 5.8-2.8 8.8-2.7 3.1-8.2 3.1-5.4 0-8.2-3-2.8-3.1-2.8-8.8v-3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m571.4 179.5l-2.3 4.3v14.4h-7.4v-47h7.4v20.5l9.7-20.5h7.4l-10.3 20.9 10.3 26.1h-7.6z"
  }))))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s9",
    cx: 220.1,
    cy: 266.6,
    r: 17.2
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s9",
    cx: 267,
    cy: 279.1,
    r: 9.4
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m916 625.8v15.5h-100.5v-15.5c0-4.2 3.3-7.6 7.5-7.6h18v-8.3c0-2.2 1.8-4 4-4 1.1 0 2.2 0.4 2.9 1.1 0.7 0.8 1.2 1.8 1.2 2.9v8.3h33.3v-8.3c0-2.2 1.8-4 4-4 2.2 0 4.1 1.8 4.1 4v8.3h18c4.1 0 7.5 3.4 7.5 7.6zm-64.2 3.9c0-2.2-1.1-4.1-2.7-5.3v2.1c0 2.3-1.8 4.1-4.1 4.1-2.2 0-4-1.8-4-4.1v-2.1c-1.6 1.2-2.7 3.1-2.7 5.3 0 3.8 3 6.8 6.7 6.8 3.8 0 6.8-3 6.8-6.8zm41.4 0c0-2.2-1.1-4.1-2.7-5.3v2.1c0 2.3-1.9 4.1-4.1 4.1-2.2 0-4-1.8-4-4.1v-2.1c-1.6 1.2-2.7 3.1-2.7 5.3 0 3.8 3 6.8 6.7 6.8 3.8 0 6.8-3 6.8-6.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m815.5 647h100.5v49.5c0 3.1-2.5 5.6-5.6 5.6h-89.3c-3.1 0-5.6-2.5-5.6-5.6zm71.6 20c0 0.8 0.7 1.4 1.5 1.4h9.9c0.8 0 1.4-0.6 1.4-1.4v-10c0-0.8-0.6-1.4-1.4-1.4h-9.9c-0.8 0-1.5 0.6-1.5 1.4zm0 24.4c0 0.8 0.7 1.4 1.5 1.4h9.9c0.8 0 1.4-0.6 1.4-1.4v-10c0-0.8-0.6-1.4-1.4-1.4h-9.9c-0.8 0-1.5 0.6-1.5 1.4zm-27.8-24.3c0 0.8 0.7 1.4 1.5 1.4h9.9c0.8 0 1.4-0.6 1.4-1.4v-10c0-0.8-0.6-1.4-1.4-1.4h-9.9c-0.8 0-1.5 0.6-1.5 1.4zm0 24.4c0 0.8 0.7 1.4 1.5 1.4h9.9c0.8 0 1.4-0.6 1.4-1.4v-10c0-0.8-0.6-1.4-1.4-1.4h-9.9c-0.8 0-1.5 0.6-1.5 1.4zm-27.8-24.3c0 0.8 0.7 1.4 1.5 1.4h9.9c0.8 0 1.4-0.6 1.4-1.4v-10c0-0.8-0.6-1.4-1.4-1.4h-9.9c-0.8 0-1.5 0.6-1.5 1.4zm0 24.4c0 0.8 0.7 1.4 1.5 1.4h9.9c0.8 0 1.4-0.6 1.4-1.4v-10c0-0.8-0.6-1.4-1.4-1.4h-9.9c-0.8 0-1.5 0.6-1.5 1.4z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommuni);
export default __webpack_public_path__ + "static/media/communi.4578e2b43e9a58b4d760bbc87fc740c2.svg";
export { ForwardRef as ReactComponent };